import React from 'react';
import './tiles.scss';

function AltovaProductTile({ title, content, image, url }) {
    return (
        <div className="summary-container">
            <div className="summary-container--image-holder">
                <img src={image} alt={title} />
            </div>
            <div className="summary-container--text-holder">
                <a href={url} target="_blank"><h1 className="title">{title}</h1></a>
                <hr className="dashed-line" />
                <p className="content">{content}</p>
            </div>
        </div>
    );
}

export default AltovaProductTile;
